import { render, staticRenderFns } from "./Sizing.vue?vue&type=template&id=97fe6a0c&"
import script from "./Sizing.vue?vue&type=script&lang=js&"
export * from "./Sizing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports